export const PRODUCT_LOCALE = "en-US";

const FULL_DATE_FORMAT = new Intl.DateTimeFormat(PRODUCT_LOCALE, {
  year: "numeric",
  month: "short",
  day: "numeric",
});

const DATE_TIME_FORMAT = new Intl.DateTimeFormat(PRODUCT_LOCALE, {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

function parseProductDate(value: unknown): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const normalized = typeof value === "string" ? value.trim() : "";
  const wallClock = normalized.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?$/,
  );
  if (wallClock) {
    const [, year, month, day, hour = "0", minute = "0", second = "0"] =
      wallClock;
    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second),
    );
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(value as string | number);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatProductDate(value: unknown): string {
  const date = parseProductDate(value);
  return date ? FULL_DATE_FORMAT.format(date) : "Date unavailable";
}

export function formatProductDateTime(value: unknown): string {
  const date = parseProductDate(value);
  return date ? DATE_TIME_FORMAT.format(date) : "Date unavailable";
}
